import { Component, OnInit, ViewChild } from '@angular/core';
import { SponserService } from '../../Services/sponser.service';
import {ISponserData,ITblSponser,ITbl_SponserContacts, ITbl_Products, SponsorProduct} from '../../Models/sponser-data'
import { Router } from '@angular/router';
import { CodeListValues } from '../../Models/country-data';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable, } from 'rxjs';
import { } from '../../Services/canDeActivateGuard';
import { DatePipe } from '@angular/common';
import { IDeactivateGuard } from 'src/app/shared/Guards/can-deactivate-guard.service';
import { BreadcrumbService } from 'src/app/shared/Breadcrumb/breadcrumb.service';
import { AuditIdentifier, AuditLogEntities, AuditLogModule, AuditOperations, breadcrumnsCodes, Dateformat, FileExtension } from 'src/app/shared/constants/global.constants';
import { AuditLogService } from '../../../shared/ModelComparison/audit.log.service';
import { ActiveInActiveStatus } from '../../../shared/constants/global.constants';
import { AuditLogModel } from '../../../shared/ModelComparison/audit.log.response.model';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { UserService } from 'src/app/Admin/Authorization/UserRoleMapping/Services/user.service';
import { UserData, UserGroupModel } from 'src/app/Admin/Authorization/UserRoleMapping/Models/user';
import { ProductFilterDetails } from '../../Models/getSponserFilter';
import FileSaver from 'file-saver';
import { Privileges } from 'src/app/shared/constants/privileges.constants';

@Component({
  selector: 'app-createsponsor',
  templateUrl: './createsponsor.component.html',
  styleUrls: ['./createsponsor.component.css']
})
export class CreatesponsorComponent implements OnInit, IDeactivateGuard {
  unsavedChanges: boolean = false;
  displayDialog:boolean=false;
  cardData: any;
  myForm: FormGroup;
  dialogFormGroup: FormGroup;
localConatctId:number=0;
localProductId:number=0;
editContactFlag=false;
sponserData:ISponserData={};

oldSponserContact:any;
oldSponserData:any;
  sponserInfo:ITblSponser={};
  sponserContact:ITbl_SponserContacts={};
 sponserContactList:ITbl_SponserContacts[]=[];
 countryCodes: CodeListValues[] | undefined;
 submitted = false;
 isSaveBtnDisable = false;
 contactSubmitted=false;
 isDisabled: boolean = true;
 public weightConfirmed: boolean = false;
 executeCanExist: boolean = true;
 _enumBreadcrumb :any;
 changedSponsorProperties:any[] = [];
 changedSponsorContactsProperties:any[] = [];
 statusData : any[] = [];
  noOfSuppliersAreLinkedwithSponserId: any;
  selectedOption: string="";
  selectedsponserstatus: any[]=[];
  filterselectedsponserstatus: any[] =[];
  defaultstatus: any[]=[];
  contactHeader='Add Contact'
  usergroup=new UserGroupModel();
  auditIdentifierDetails:any;
  userData: UserData = new UserData();
  uniqueSponsorContactNameMessage=false;
  uniqueSponsorNameMessage=false;
  allSponsordetails: any[] = [];

  displayAddProductDialog: boolean = false;
  displayProductDialog: boolean = false;
  productList: ITbl_Products[] = [];
  selectedProducts: any;
  orginalStatusData: any;
  selectedProduct = new SponsorProduct();
  productFormGroup!: FormGroup;
  productSubmitted = false;
  uniqueProductNameMessage = false;
  totalRecordCount: number = 0;
  filteredRecordCount: number = -1;
  editPrivilege: boolean = false;
  ExportPrivilege: boolean = false;
  products: ITbl_Products = {};
  isChecked: boolean = true;
  productFilterDetailsModel = new ProductFilterDetails();
  allProducts: any;
  originalProductData: any;
  selectedRecordsToExpotToExcel: any[] = [];
  _dateformart: any;
  newProducts: any[]=[];

  sponserIdToUpdate: any; // Used to fetch specific sponsor data
  CreatedbyUserName: string = ''; // Used to display who created the record
  sponsorDetailBeforeUpdate: any; // Used for audit logging
  sponsorContactDetailListBeforeUpdate: any; // Used for audit logging
  updatedSponserContactList: any[] = []; // Used to re-map contacts with local IDs
  oldSponserContactData: any;
  @ViewChild('dt') table: any;
  
constructor(private _service:SponserService,private router:Router,
  private confirmationService: ConfirmationService,
  private messageService: MessageService,
  private fb: FormBuilder,private breadcrumbService: BreadcrumbService,
  private auditLogService:AuditLogService,
  private privilegeService: PrivilegeService, private datePipe: DatePipe,
  private _userService: UserService)
  {

    this.myForm = this.fb.group({
       sponserName: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3),Validators.pattern(/^(?=(?:.*[a-zA-Z]){3,}).*$/),this.notOnlySpacesValidator]],
      sponserAddress: ['', [Validators.maxLength(300)]],
      sponserId:[''],
      sponserNotesAndComments:['', [Validators.maxLength(300)]],
    
    });

    this.dialogFormGroup = this.fb.group({
      contactName: ['', [Validators.required,Validators.maxLength(30),Validators.pattern(/^[a-zA-Z\s]{1,30}$/),this.notOnlySpacesValidator]],
      contactDesignation:['', [Validators.maxLength(100),Validators.minLength(3),this.notOnlySpacesValidator]],
      countryCode: [''],
      phoneNumber:['',[Validators.minLength(7),Validators.maxLength(15)]],
      email:['',[Validators.required,Validators.maxLength(100)]]
    });

    this.productFormGroup = this.fb.group({
      productName: ['', [Validators.required, Validators.maxLength(200), this.notOnlySpacesValidator]],
      longName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      genericName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      internalName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      tradeName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      productStatus: ['', [Validators.required]],
    });

    this.isDisabled=true;
  }

  notOnlySpacesValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value && control.value.trim() === '') {
       return { 'onlySpaces': true };
     }
     return null;
   }

   validateOnlyNumberandSpecialCharecters(control: AbstractControl): ValidationErrors | null{
    const alphaRegex = /[a-zA-Z]/; // Ensure at least one alphabetic character
    if (control.value && !alphaRegex.test(control.value)) {
      return { invalidNumberSpecialCharecters: true };
    }
    return null;
  }
  validateAlphaCharacters(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    
    const pattern = /^[a-zA-Z\s]*$/;

    if (value && !pattern.test(value)) {
      return { invalidAlphaCharacters: true };
    }

    return null;
  }
  auditEntities:any;
  auditOperations:any;
  auditModule:any;
  oldSponsorInfo:any;
  oldSponsorContactInfo:any;
  ngOnInit(): void {
    this.userData=this.privilegeService.getUserData();
    this._dateformart = Dateformat;
      this.usergroup.userId=this.userData.id;
      this.usergroup.email=this.userData.emailId;
      this.usergroup.groupTypeCode=this.userData.groupTypeCode;
    this._enumBreadcrumb=breadcrumnsCodes;
    this.auditIdentifierDetails=AuditIdentifier; 
    this.auditEntities=AuditLogEntities;
    this.auditOperations=AuditOperations;
    this.auditModule=AuditLogModule;

    this.generateBreadcrumb();
    localStorage.setItem('LoggedInUserName', 'TestUser');
    this._service.getCodeListData(0,'').subscribe(
      data=>{
        this.countryCodes=data.data;
        
      }
    );
    this.GetsponserStatus();
    this.getProductData();
    this.BindPrivileges();
    this.oldSponserData=JSON.stringify(this.sponserData);
    this.oldSponserContact=JSON.stringify(this.sponserContact);

    setTimeout(() => {
      this.oldSponsorInfo=JSON.stringify(this.sponserInfo);
      this.oldSponsorContactInfo=JSON.stringify(this.sponserContact);
    }, 1000);
    this.GetAllSponsors();
    this.productFormGroup.get('productStatus')?.valueChanges.subscribe(value => {
  });
  }

  updateUserGroup(GroupId:number)
  {
    this.usergroup.groupId=GroupId;
    this._userService.UpdateUserGroup(this.usergroup).subscribe(
      data=>{
        this.privilegeService.setGroup(GroupId,1);
       
      }
    );
  }
  saveSponserData(){
    this.ClearFilters();
    this.submitted = true;
    this.isSaveBtnDisable = true;
    setTimeout(() => {
      this.isSaveBtnDisable = false;
    }, 3000);
    if (this.myForm.valid && !this.uniqueSponsorNameMessage) {
      this.executeCanExist = false;
    this.sponserInfo.createdBy=this.privilegeService.getLoginUserId();
    this.sponserInfo.createdDate=new Date();
    this.sponserInfo.sponserId='';
    if(this.sponserInfo.address == undefined){
      this.sponserInfo.address="";
    }
    if(this.sponserInfo.notesAndComments == undefined){
      this.sponserInfo.notesAndComments="";
    }

    this.sponserData["sponserInfo"]=this.sponserInfo;

    this.sponserData["sponserContacts"]=this.sponserContactList;
    const cleanedProducts = (this.newProducts || []).map((p: {id:any, productName: any; longName: any; genericName: any; internalName: any; tradeName: any; statusMappingId: any; isDeleted: any; }) => ({
      id: p.id,
      productName: p.productName || null,
        longName: p.longName || null,
        genericName: p.genericName || null,
        internalName: p.internalName || null,
        tradeName: p.tradeName || null,
        statusMappingId: p.statusMappingId || null,
        isDeleted: p.isDeleted ?? false
      }));

    this.sponserData["Products"] = cleanedProducts;
     
    this._service.saveSponserData(this.sponserData).subscribe(
      data=>{
        if(this.usergroup.groupTypeCode=='SPO')
        {
          this.updateUserGroup(data.data)
        }
        this.messageService.add({
          key: 'tc',
          severity: 'success',
          summary: 'Sponsor Information has been saved',
          detail: '',
      });
        this.localConatctId=0;

        //This line was used for Audit log
        this.compareModels();

        this.router.navigate(['/viewsponsor',data.data]);
      }
    );
    }
    else{
      this.messageService.add({  key: 'tc',severity: 'warn', summary: 'Please enter required information', detail: '' });
    }
  }



      changedSponsorBasicInfo:any;
      changedSponsorContactInfo:any;
      listChangedSponsorBasicContactInfo:any;
      auditModelForSponser=new AuditLogModel();
      auditModelForSponserContact=new AuditLogModel();
  compareModels() {
            //This code is for testing point of view
  
//Get Method Direct URL
    this.auditLogService.GetAuditDetailById().subscribe(
      data => {

      }
    );

  

        //Getting Changes Properties Array for Sponsor
        this.changedSponsorBasicInfo = this.auditLogService.compareModels(JSON.parse(this.oldSponserData),this.sponserInfo,this.auditEntities.SponsorDetails,this.auditIdentifierDetails.SponsorDetails,this.auditOperations.Create, this.auditModule.Sponsorservice);
       
      //Getting Changes Properties Array for Sponsor Contacts
        this.sponserContactList.forEach((item:any) => {
          this.changedSponsorContactInfo=this.auditLogService.compareModels(JSON.parse(this.oldSponserContact),item,this.auditEntities.SponsorContacts,this.auditIdentifierDetails.SponsorContacts,this.auditOperations.Create,this.auditModule.Sponsorservice);
        });
        }

  openContactModel(){
    this.uniqueSponsorContactNameMessage=false;
    this.currentSponsorContactIndex=-1;
      this.dialogFormGroup.reset();
      Object.keys(this.dialogFormGroup.controls).forEach(key => {
          this.dialogFormGroup?.get(key)?.setErrors(null);
          
      });
      this.contactSubmitted=false;
      this.sponserContact.name="";
      this.sponserContact.designation="";
      this.sponserContact.countryCode="";
      this.sponserContact.phoneNumber="";
      this.sponserContact.email="";
      this.displayDialog = true;
      this.contactHeader='Add Contact';
      this.iscontactExist=false;

  }
  isSavePopupBtnDisable = false;
  SaveContact(){
    this.isSavePopupBtnDisable = true;
    setTimeout(() => {
      this.isSavePopupBtnDisable = false;
    }, 3000);
    this.contactSubmitted=true;
    this.trimInput();
    if (this.dialogFormGroup.valid && ! this.uniqueSponsorContactNameMessage && !this.uniqueSponsorNameMessage) {
    this.contactSubmitted=false;
    this.sponserContact.createdBy= this.privilegeService.getLoginUserId();
    this.sponserContact.createdDate=new Date();
    this.sponserContact.updatedBy=this.privilegeService.getLoginUserId();
    this.sponserContact.updatedDate=new Date();
    this.sponserContact.isDeleted=false;
    this.sponserContact.id=0;

    if(!this.editContactFlag){
    this.sponserContact.localId=this.localConatctId;
    this.editContactFlag=false;
    }
   
    const index = this.sponserContactList.findIndex(model => model.localId === this.sponserContact.localId);
    if (index !== -1) 
    {
      this.sponserContactList[index] = this.sponserContact;
  
    } 
  else
  {
    this.sponserContactList.push(this.sponserContact);
  }
   
    
    this.sponserContact={};
    this.localConatctId=this.localConatctId+1;
    this.displayDialog = false;
    this.messageService.add({
      key: 'tc',
      severity: 'success',
      summary: 'Contact Information has been saved',
      detail: '',
  });
    
    }
    this.editContactFlag=false;
  }

  trimInput() {
    const control = this.dialogFormGroup.get('contactName');
    if (control && control.value) {
      control.setValue(control.value.trim());
    }
  }

  editContact(cardData:any,rowIndex:any){
    this.uniqueSponsorContactNameMessage=false;
    this.sponserContact.name=cardData?.name;
    this.sponserContact.designation=cardData?.designation;
    this.sponserContact.countryCode=cardData?.countryCode;
    this.sponserContact.phoneNumber=cardData?.phoneNumber;
    this.sponserContact.email=cardData?.email;
    this.sponserContact.localId=cardData?.localId;
    this.editContactFlag=true;
    this.displayDialog = true;
    this.contactHeader='Edit Contact';
    this.currentSponsorContactIndex=rowIndex;
  }

  deleteContact(contactId: any){
    this.confirmationService.confirm({
      header:'Confirm',
      message: 'Are you sure you want to delete this contact from this Sponsor?',
      accept: () => {
        
        const index = this.sponserContactList.findIndex(model => model.localId === contactId);
        if (index !== -1) {
          this.sponserContactList.splice(index, 1);
          this.messageService.add({  key: 'tc',severity: 'success', summary: 'Contact has been deleted', detail: '' });
        } 
      },
      

    });
  }


  closeDialog(){
    this.displayDialog = false;
    this.editContactFlag=false;
    this.messageService.add({
      key: 'tc',
      severity: 'info',
      summary: 'Contact Information has not been saved',
      detail: '',
  });
    
  }



  BackToListPage(){
    setTimeout(() => {
      this.router.navigate(['/sponsor']);
    }, 1000);
   
  }

  creSponcheckSponsorContactNameExist(contactDetails:any)
    {
      if(this.sponserContactList.length>0){
        if (this.isNameRepeated(contactDetails)) {
          this.uniqueSponsorContactNameMessage=true;
        } else {
          this.uniqueSponsorContactNameMessage=false;
        }
      }
    }
    currentSponsorContactIndex=-1;
    isNameRepeated(contactDetails: any): boolean {

      this.uniqueSponsorContactNameMessage=false;
          let nameCount = 0;
          const contactName = contactDetails.name.toLowerCase();
          if(this.currentSponsorContactIndex==-1) 
          {
            this.sponserContactList.forEach((obj: any, index: any) => {
              if (obj.name.toLowerCase() === contactName) {
                  nameCount++;
              }
          });
          }
          else if(this.currentSponsorContactIndex>=0){
            this.sponserContactList.forEach((obj: any, index: any) => {
              if (obj.name.toLowerCase() === contactName &&  index!=this.currentSponsorContactIndex) {
                  nameCount++;
              }
          });
          }
    
          return nameCount > 0;
      }
  canExist(): boolean | Promise<boolean> | Observable<boolean> {
    if (this.executeCanExist && ((this.oldSponsorInfo!=JSON.stringify(this.sponserInfo)) || (this.sponserContactList.length>0)))
    {
      return new Promise<boolean>((resolve) => {
        this.confirmationService.confirm({
          message: 'Sponsor will not be saved, Do you want to continue?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.messageService.add({
              key: 'tc',
              severity: 'info',
              summary: 'Sponsor not saved',
              detail: '',
          });
            resolve(true); 
          },
          reject: () => {
            resolve(false); 
          },
        });
      });
    }
    else{
      return true;
    }
    
  }
  generateBreadcrumb()
  {
    this.breadcrumbService.generateBreadcrumb(this._enumBreadcrumb.CSP);
  }
  getBreadcrumbs(): MenuItem[] {
    return this.breadcrumbService.getBreadcrumbs();
  }
  GetsponserStatus(){
    this._service.getCodeListData(3,'Sponser').subscribe(
      data=>{
        this.statusData=data.data;
        this.orginalStatusData = data.data;
        this.defaultstatus=this.statusData.filter((x:any)=>x.name==ActiveInActiveStatus.Active);
        this.getProductData();
      }
    );
   
  }
  contactUniqueMessage:string="";
  iscontactExist=false;
IsCheckDuplicateContact(name: any): void {
  this.contactUniqueMessage="Contact Name already exists in this Sponsor. Please enter a unique Name";
  this.iscontactExist= this.sponserContactList.some(obj=>obj.name?.toLowerCase()===name.toLowerCase())

}
  onOptionChange(event:any): void { 
  
  }
  //get all suppliers data
GetAllSponsors() {
  this._service.GetAllSponsers().subscribe(
    (    res: { data: any[]; })=>{
      this.allSponsordetails=res.data;
    } 
 );
};
  checkSponsorNameExist()
  {
    this.uniqueSponsorNameMessage=false;
  const contactIndex = this.allSponsordetails.findIndex(item => item.name.toLowerCase() === (this.sponserInfo.name?.toLocaleLowerCase()));
   if(contactIndex !== -1)
   {
      this.uniqueSponsorNameMessage=true;
   }
    else{
      this.uniqueSponsorNameMessage=false;
    }
  }
  onfilter(event: any) {
    this.productList = [...this.allProducts];

      const productSearch = this.productFilterDetailsModel.ProductName?.toLowerCase();

      if (!productSearch) {
      this.productList = [...this.allProducts];
      } 
    else {
      this.productList = this.productList.filter(a =>
      a.productName?.toLowerCase().includes(productSearch) ||
      a.longName?.toLowerCase().includes(productSearch) ||
      a.genericName?.toLowerCase().includes(productSearch) ||
      a.internalName?.toLowerCase().includes(productSearch) ||
      a.tradeName?.toLowerCase().includes(productSearch)
    );

    }
    this.filteredRecordCount = this.productList.length;
     this.table.first = 0;
  }

  ClearFilters() {
    this.productFilterDetailsModel = {
      ProductName: '',
      longName: '',
      genericName: '',
      internalName: '',
      tradeName: ''
    }
  this.productList = [...this.allProducts];
  this.filteredRecordCount = this.productList.length;

  }

  onAddProduct() {
    this.productSubmitted = false;
    this.uniqueProductNameMessage = false;
    this.products.productName = '';
    this.products.longName = '';
    this.products.genericName = '';
    this.products.internalName = '';
    this.products.tradeName = '';
    this.displayAddProductDialog = true;
     }
updatedByName:any;
  onEditProduct(product: any) {

    this.selectedProduct = { ...product };
    this.originalProductData = { ...product };
    this.displayProductDialog = true;
    if (this.selectedProduct?.updatedBy) {
       if (this.selectedProduct.updatedBy) {
  this.updatedByName = product.updatedBy;
}
}
  }

  onCancelProduct() {
    const formValues = this.productFormGroup.value;

    const isChanged = Object.values(formValues).some(value =>
      value !== null && value !== undefined && value !== '');

    if (isChanged) {

      this.confirmationService.confirm({
        message: 'If you cancel, the entered Product Details will be lost and not saved. Do you want to continue?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes',
        rejectLabel: 'No',

        accept: () => {
          this.displayAddProductDialog = false;
          this.productFormGroup.reset();
          this.newProducts = []

          Object.keys(this.productFormGroup.controls).forEach(key => {
            this.productFormGroup.get(key)?.setErrors(null);
            this.productFormGroup.get(key)?.markAsPristine();
            this.productFormGroup.get(key)?.markAsUntouched();
          });

          this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
        },

        reject: () => {
        }
      });

    } else {
          this.displayAddProductDialog = false;

          this.productFormGroup.reset();

          Object.keys(this.productFormGroup.controls).forEach(key => {
            this.productFormGroup.get(key)?.setErrors(null);
            this.productFormGroup.get(key)?.markAsPristine();
            this.productFormGroup.get(key)?.markAsUntouched();
          });

          this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
    }

  }

  onCancelEditProduct() {
    const currentData = JSON.stringify(this.selectedProduct);
    const originalData = JSON.stringify(this.originalProductData);
    const isChanged = currentData !== originalData;

    if (isChanged) {
      this.confirmationService.confirm({
        message: 'If you cancel, the entered Product Details will be lost and not saved. Do you want to continue?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes',
        rejectLabel: 'No',

        accept: () => {

          this.displayProductDialog = false;
          this.selectedProduct = { ...this.originalProductData };
          this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
          this.productFormGroup.reset();

          Object.keys(this.productFormGroup.controls).forEach(key => {
            this.productFormGroup.get(key)?.setErrors(null);
            this.productFormGroup.get(key)?.markAsPristine();
            this.productFormGroup.get(key)?.markAsUntouched();
          });
        },

        reject: () => {
        }
      });

    } else {
      this.displayProductDialog = false;
       this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
          this.productFormGroup.reset();

          Object.keys(this.productFormGroup.controls).forEach(key => {
            this.productFormGroup.get(key)?.setErrors(null);
            this.productFormGroup.get(key)?.markAsPristine();
            this.productFormGroup.get(key)?.markAsUntouched();
          });
    }
    this.updatedByName = null;

  }

   saveProduct() {

     this.productSubmitted = true;
     this.productFormGroup.markAllAsTouched();


     if (this.productFormGroup.invalid || this.uniqueProductNameMessage) {
       this.messageService.add({
         key: 'tc',
         severity: 'warn',
         summary: 'Please enter required information',
         detail: ''
       });
       return;
     }

    this.executeCanExist = false;
    const objProductData: any = {

       localId: this.localProductId, 
      productName: this.products.productName,
      longName: this.products.longName,
      genericName: this.products.genericName,
      internalName: this.products.internalName,
      tradeName: this.products.tradeName,

      statusMappingId: this.products.statusMappingId,

      createdBy: this.privilegeService.getLoginUserId(),
      createdDate: new Date().toISOString(),
     

      isDeleted: false,
      updatedBy: null,
      updatedDate: null
    };

    const statusMap = new Map<number, string>();
    this.statusData.forEach((status: { id: number; name: string }) => {
      statusMap.set(status.id, status.name);
    });


    const statusId = Number(objProductData.statusMappingId);
    objProductData.status = statusMap.get(statusId) || 'Unknown';
 
  this.productList = [...this.productList, { ...objProductData }];
  this.allProducts = [...this.allProducts, { ...objProductData }];
  this.newProducts = [...this.newProducts, { ...objProductData }];

  this.localProductId = this.localProductId + 1;
   this.totalRecordCount = this.productList.length;

    if (this.filteredRecordCount > -1) {
      this.filteredRecordCount = this.productList.length;
    }


      
       this.messageService.add({
           key: 'tc',
           severity: 'success',
           summary: 'Product Information has been saved',
           detail: ''
         });
         this.displayAddProductDialog = false;
         this.productFormGroup.reset();

         Object.keys(this.productFormGroup.controls).forEach(key => {
           this.productFormGroup.get(key)?.setErrors(null);
           this.productFormGroup.get(key)?.markAsPristine();
           this.productFormGroup.get(key)?.markAsUntouched();
         });
       


   }

onUpdateProduct() {

  const statusMap = new Map<number, string>();
  this.statusData.forEach((status: { id: number; name: string }) => {
    statusMap.set(status.id, status.name);
  });

  const matchProduct = (p: any, selected: any) => {

    if (p.localId != null && selected.localId != null) {
      return p.localId === selected.localId;
    }

    if (p.id != null && selected.id != null) {
      return p.id === selected.id;
    }

    return false;
  };

  this.selectedProduct = {
    ...this.selectedProduct,
    statusMappingId: this.selectedProduct.statusMappingId,
    status: statusMap.get(Number(this.selectedProduct.statusMappingId)),
    updatedBy: this.privilegeService.getUserName(this.privilegeService.getLoginUserId()),
    updatedDate: new Date(
        new Date().toISOString()
    ),
  };

  const updateList = (list: any[]) => {
    return list.map(product => {
      if (matchProduct(product, this.selectedProduct)) {
        return {
          ...product,
          statusMappingId: this.selectedProduct.statusMappingId,
          status: this.selectedProduct.status,
          updatedBy: this.selectedProduct.updatedBy,
          updatedDate: this.selectedProduct.updatedDate,
        };
      }
      return product;
    });
  };

  this.productList = [...updateList(this.productList)];
  this.allProducts = updateList(this.allProducts);

  const existsInNewProducts = this.newProducts.some(p =>
    matchProduct(p, this.selectedProduct)
  );

  if (existsInNewProducts) {

    this.newProducts = updateList(this.newProducts);

  } else {

    const fullProduct = this.productList.find(p =>
      matchProduct(p, this.selectedProduct)
    );

    if (fullProduct) {
      this.newProducts = [
        ...this.newProducts,
        { ...fullProduct }
      ];
    }
  }

  this.messageService.add({
    key: 'tc',
    severity: 'success',
    summary: 'Product Information has been saved',
    detail: '',
  });

  this.displayProductDialog = false;

  this.productFormGroup.reset();

  Object.keys(this.productFormGroup.controls).forEach(key => {
    const control = this.productFormGroup.get(key);
    control?.setErrors(null);
    control?.markAsPristine();
    control?.markAsUntouched();
  });
  this.updatedByName = null;
  this.selectedProducts = []
}


  ExportProductData() {

    this.selectedRecordsToExpotToExcel = this.selectedProducts;
    const dataToExport = this.selectedRecordsToExpotToExcel.map((product) => {
      return {
        'Product Name': product.productName,
        'Long Name': product.longName,
        'Generic Name': product.genericName,
        'Internal Name': product.internalName,
        'Trade Name': product.tradeName,
        'Lifecycle State': this.statusData.find((status: any) => status.id == product.statusMappingId).name,
        'Modified By': product.updatedBy,
        'Modified Date and Time':product.updatedDate!=null?this.convertDateTimeFormat(product.updatedDate):product.updatedDate,

      };
    });
    this.exportExcel(dataToExport);

  }


convertDateTimeFormat(inputDateTime: any) {
  const date = new Date(inputDateTime); 

  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' }).format(date);
  const year = date.getUTCFullYear();

  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes} UTC`;
}

  exportExcel(SelectedRecords: any) {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(SelectedRecords);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Products");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = FileExtension.ExportExtention;
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName);
    }

  CheckboxEnabled() {
    if (this.selectedProducts.length > 0) {
      this.isChecked = false;
    }
    else {
      this.isChecked = true;
    }
  }
  
  checkProductNameExist(productDetails: any) {
    if (this.productList.length > 0) {
      if (this.isNameRepeated(productDetails)) {
        this.uniqueProductNameMessage = true;
      } else {
        this.uniqueProductNameMessage = false;
      }
    }
  } 

    BindPrivileges(){
      const hasPermission = (privilege: Privileges) => this.privilegeService.hasPermission(privilege);
      this.editPrivilege = hasPermission(Privileges.EditSponsor);
      this.ExportPrivilege = hasPermission(Privileges.ExportlistofSponsors);
    }

getProductData() { 
    this._service.getMasterProducts().subscribe(
        res => {
            this.selectedProducts = [];
            this.isChecked = true;
            if (res && res.data && res.data.length > 0) {

                this.allProducts = res.data;
                this.allProducts = res.data.map((p: { updatedDate: string; createdDate: string; }) => ({
                  ...p,
                  updatedDate: p.updatedDate ? new Date(p.updatedDate + 'Z') : null,
                  createdDate: p.createdDate ? new Date(p.createdDate + 'Z') : null
                }));
                this.productList = [...this.allProducts];

                const statusMap = new Map<number, string>();
                this.statusData.forEach((status: { id: number; name: string }) => {
                  statusMap.set(status.id, status.name);
                });

                this.productList.forEach((product: any) => {
                  const statusId = Number(product.statusMappingId);
                  product.status = statusMap.get(statusId) || 'Unknown';

                  product.createdBy = this.privilegeService.getUserName(product.createdBy);
                  product.updatedBy = this.privilegeService.getUserName(product.updatedBy);
                });

                this.totalRecordCount = this.productList.length;
            }
        },
    );
}
  
}
